/* @flow */

import Reflux from "reflux";

import { validateWebShopAddress } from "../clients/CustomerServiceClient";

import { AddressValidation } from "../datatypes/customer/AddressValidation";
import { AddressType } from "../datatypes/Address";

let validation: AddressValidation | undefined | null;

const AddressValidationStore = Reflux.createStore({
    validateWebShopAddress(address: AddressType, successCallback: (x0: AddressValidation | undefined | null) => void) {
        validation = null;
        validateWebShopAddress(address)
            .then((body) => {
                validation = body;
                this.trigger();
                if (body && body.valid) {
                    successCallback(validation);
                }
            })
            .catch(() => {
                // If we cannot validate, we might as well just try and add it.
                validation = null;
                this.trigger();
                successCallback(validation);
            });
    },

    getValidation(): AddressValidation | undefined | null {
        return validation;
    },

    reset() {
        validation = null;
        this.trigger();
    }
});

export default AddressValidationStore;
